export class ReportTimeTrack {
  userFullName: string = ''
  clientName: string = ''
  projectName: string = ''
  workingHours: number = 0
  chargeableHours: number = 0
}
